module.exports = new __parcel__URL__("hyperwall.f504acea.png").toString();